export default __webpack_public_path__ + "static/media/Vengeance.0ac48dfb.jpg";